/** @prettier */

import { camsAndForecastsPaths } from './utils/urls/camsAndForecastsPath';
import { spotForecastPaths } from './utils/urls/spotForecastPath';
import { subregionForecastPaths } from './utils/urls/subregionForecastPath';
import { subregionForecastChartsPaths } from './utils/urls/subregionForecastChartsPath';

export const CamAndForecastsRoute = {
  routeProps: {
    path: camsAndForecastsPaths.base,
    exact: true,
  },
  loader: () =>
    import(
      /* webpackChunkName: "CamsAndForecasts" */
      './containers/routes/CamsAndForecasts/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/CamsAndForecasts/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/CamsAndForecasts/index.js')],
};

export const GeonameMapRoute = {
  routeProps: {
    path: `${camsAndForecastsPaths.base}/*/:geonameId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "GeonameMap" */
      './containers/routes/GeonameMap/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/GeonameMap/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/GeonameMap/index.js')],
};

export const MapPageRoute = {
  routeProps: {
    path: `${camsAndForecastsPaths.base}-${camsAndForecastsPaths.map}(/@)?:location?`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "Map" */
      './containers/routes/Map/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/Map/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/Map/index.js')],
};

export const SpotPageRoute = {
  routeProps: {
    path: spotForecastPaths.report,
  },
  loader: () =>
    import(
      /* webpackChunkName: "Spot" */
      './containers/routes/Spot/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/Spot/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/Spot/index.js')],
};

export const PremiumAnalysisRoute = {
  routeProps: {
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId/${subregionForecastPaths.premiumAnalysis}`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "PremiumAnalysis" */
      './containers/routes/SubregionForecastPage/PremiumAnalysis/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/PremiumAnalysis/index.js'],
  webpack: () => [
    require.resolveWeak('./containers/routes/SubregionForecastPage/PremiumAnalysis/index.js'),
  ],
};

export const SubregionForecastRoute = {
  routeProps: {
    exact: true,
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecast" */
      './containers/routes/SubregionForecastPage/SubregionForecast/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/SubregionForecast/index.js'],
  webpack: () => [
    require.resolveWeak('./containers/routes/SubregionForecastPage/SubregionForecast/index.js'),
  ],
};

export const SubregionForecastPageRoute = {
  routeProps: {
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecastPage" */
      './containers/routes/SubregionForecastPage/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage/index.js')],
  childRoutes: [SubregionForecastRoute, PremiumAnalysisRoute],
};

export const ChartsPageRoute = {
  routeProps: {
    path: `${subregionForecastChartsPaths.base}/:chartSlug/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "ChartsPage" */
      './containers/routes/SubregionForecastPage/Charts/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/Charts/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage/Charts/index.js')],
};

export const ChartsPageContainerRoute = {
  routeProps: {
    isMultiPage: true,
    path: `${subregionForecastChartsPaths.base}/:chartSlug/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecastPage" */
      './containers/routes/SubregionForecastPage/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage/index.js')],
  childRoutes: [ChartsPageRoute],
};

export const SessionsClipRoute = {
  routeProps: {
    path: `/sessions/clips/:clipId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SessionsClip" */
      './containers/routes/SessionsClip/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/SessionsClip/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/SessionsClip/index.js')],
};

export const SessionRoute = {
  routeProps: {
    path: `/sessions/:sessionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SessionPage" */
      './containers/routes/Sessions/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/Sessions/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/Sessions/index.js')],
};

export const RateLimitTestPage = {
  routeProps: {
    path: `/rl-test-page/`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "RateLimitRoute" */
      './containers/routes/RateLimitTestPage/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/RateLimitTestPage/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/RateLimitTestPage/index.js')],
};

const NotFoundRoute = {
  routeProps: {
    path: '*',
    status: 404,
  },
  loader: () =>
    import(
      /* webpackChunkName: "NotFound" */
      './containers/routes/NotFound/index.js'
    ),
  loading: () => null,
  modules: ['./containers/routes/NotFound/index.js'],
  webpack: () => [require.resolveWeak('./containers/routes/NotFound/index.js')],
};

export default [
  CamAndForecastsRoute,
  GeonameMapRoute,
  MapPageRoute,
  SpotPageRoute,
  SubregionForecastPageRoute,
  ChartsPageContainerRoute,
  SessionsClipRoute,
  SessionRoute,
  RateLimitTestPage,
  NotFoundRoute,
];
